function format_time_formal(timestamp) {
    let date = new Date(timestamp)
        .toTimeString()
        .replace("GMT+0700 (Western Indonesia Time)", "WIB");
    const time = date.split(" ")
    const clock = `${time[0]?.split(":").slice(0, 2).join(":")} ${time[1]}`
    return clock
}

export default format_time_formal;